import { find, findAll, register, prefixUtil } from '../../../../Javascript/Sysmex/Utils'

const prefixString = 'sysmexAtomSelect'
const prefix = prefixUtil(prefixString)
const classPrefix = prefixUtil(`.${prefixString}`)

const Select = el => {
  // open if click on select
  const inputContainer = find(classPrefix('container'), el)
  const submitOnChange = el.dataset.submitonchange

  const closeEventHandler = (event) => {
    if (!el.contains(event.target)) {
      close(el)
    }
  }

  const toggle = (el, event) => {
    // stop propagation of close event from surrounding close
    if (el.classList.toggle(prefix('open'))) {
      // close if click outside
      window.addEventListener('click', closeEventHandler)
    } else {
      window.removeEventListener('click', closeEventHandler)
    }
  }

  const close = (el) => {
    el.classList.remove(prefix('open'))
    window.removeEventListener('click', closeEventHandler)
  }

  inputContainer.addEventListener('click', toggle.bind(this, el))

  // input that displays the text
  const input = find(classPrefix('input'), inputContainer)

  // input that contains the value
  const hiddenInput = find('[data-hidden-value]', el)

  const setValues = (input, hiddenInput, textContent, value) => {
    // set values
    input.value = textContent
    hiddenInput.value = value

    // fire change event to simulate change for usual select box
    let event
    if (typeof Event === 'function') {
      event = new window.Event('change')
    } else {
      event = document.createEvent('Event')
      event.initEvent('change', true, true)
    }

    hiddenInput.dispatchEvent(event)
  }

  const selectOption = (params, event) => {
    // do NOT close select now
    event.stopPropagation()

    const { options, input, hiddenInput, el } = params
    const current = event.target

    // mark all options as non-active
    options.forEach(option => option.classList.remove(prefix('active')))

    // mark current as active
    current.classList.add(prefix('active'))

    setValues(input, hiddenInput, current.textContent, current.dataset.value)

    if (submitOnChange) {
      const parentForm = input.form
      const submitEvent = new window.Event('submit', {
        bubbles: true,
        cancelable: true
      })

      if (parentForm) {
        if (parentForm.dispatchEvent(submitEvent)) {
          parentForm.submit()
        }
      }
    }

    close(el)
  }

  const options = findAll(classPrefix('option'), el)
  // trigger select if click on option
  options.forEach(option => {
    option.addEventListener('click', selectOption.bind(this, { options, input, hiddenInput, el }))
    if (option.classList.contains(prefix('active'))) {
      input.value = option.textContent
    }
  })

  const hideAll = options => {
    options.forEach(option => {
      option.style.display = (option.dataset.value !== '') ? 'none' : ''
      option.classList.remove(prefix('active'))
    })
    if (options[0].dataset.value === '') {
      // show legend as selected
      options[0].classList.add(prefix('active'))
    }
  }

  // hide all elements that don't belong to parent with given changedParentKey
  const filterOptions = (changedParentKey, options, filter, input, hiddenInput) => {
    let countVisibleElements = 0
    let activeElement = null
    let lastVisibleElement = null
    options.forEach(option => {
      const key = option.dataset.value
      // dataset.value is empty for first label - this should always be displayed
      if (option.dataset.value === '' || ((changedParentKey in filter) && (filter[changedParentKey].indexOf(Number.parseInt(key)) !== -1))) {
        // show element because it's included in list
        option.style.display = ''
        // count visible elements containing a value for later auto selection if there is only one
        countVisibleElements++
        lastVisibleElement = option
        if (option.classList.contains(prefix('active'))) {
          activeElement = option
        }
      } else {
        option.style.display = 'none'
        // remove previous selection if option is going to be hidden
        if (option.classList.contains(prefix('active'))) {
          option.classList.remove(prefix('active'))
          input.value = ''
          hiddenInput.value = ''
        }
      }
    })
    // countVisibleElements == 1 means: 1st elem is legend
    // countVisibleElements == 2 means: 1st elem is legend, 2nd is last selectable value
    if (countVisibleElements <= 2) {
      if (activeElement !== null && activeElement.dataset.value === '' && countVisibleElements === 2) {
        // legend was selected, unselect it first
        activeElement.classList.remove(prefix('active'))
      }
      // preselect option if exactly one is visible
      setValues(input, hiddenInput, lastVisibleElement.textContent, lastVisibleElement.dataset.value)
      // mark current as active
      lastVisibleElement.classList.add(prefix('active'))
      activeElement = lastVisibleElement
    } else {
      // more than 2 options but nothing selected, so select legend
      if (countVisibleElements > 2 && activeElement === null) {
        // all active elements have been hidden to activate first element per default
        setValues(input, hiddenInput, options[0].textContent, options[0].dataset.value)
        options[0].classList.add(prefix('active'))
      }
    }
  }

  // check if we are dependent on parent
  if (el.dataset.parent) {
    const parentElement = document.getElementsByName(el.dataset.parent)[0]
    const filter = el.dataset.filter ? JSON.parse(el.dataset.filter) : {}
    parentElement.addEventListener('change', (e) => {
      filterOptions(e.target.value, options, filter, input, hiddenInput)
    })
    hideAll(options)
    // preselection on init
    filterOptions(parentElement.value, options, filter, input, hiddenInput)
  }
}

register('Select', Select)
